/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Account {
  account_number: string;
  clearing_number?: string | null;
  bank_id?: number | null;
  bank_name?: string | null;
}

export interface Address {
  BasicAreaName?: string | null;
  BasicAreaNumber?: string | null;
  ConcatenatedAddress?: string | null;
  FullAddress?: string | null;
  Municipality?: string | null;
  Postcode?: string | null;
  PostcodeArea?: string | null;
  Rest?: string | null;
  StreetLetter?: string | null;
  StreetName?: string | null;
  StreetNumber?: string | null;
}

export interface ApplicantDocument {
  document_id: string;
  document_type: string | DocumentType;
}

export interface ApplicantNO {
  country?: string;
  pni: string;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: boolean | null;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: EmployerNO | null;
  ev_estate?: EvEstate[] | null;
  ev_estates?: EvPropertyOutput[] | null;
  citizenship_iso_codes?: string[] | null;
  externally_verified_credits?: ExternallyVerifiedCreditOutput[] | null;

  /** @format uuid */
  customer_id: string;
  credit_check?: CreditCheckNO | null;
  external_block_check?: ExternalBlockCheckNO | null;
  block_list?: BlockList | null;
  gender?: Gender | null;
  blocked_credit_check_timestamp?: string | null;
  gr_consent?: boolean;
  last_externally_verified_credits_consent?: string | null;
}

export interface ApplicantSE {
  country?: string;
  pni: string;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: any;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: EmployerSE | null;
  census_registration_year?: string | null;
  credit_regulation_information?: CreditRegulationInformation[] | null;
  credit_regulations?: CreditRegulation[] | null;
  case_collection?: CaseCollectionItem[] | null;
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  current_frame?: CurrentFrameItem[] | null;
  html?: string | null;
  last_queries?: LastQuery[] | null;
  notes?: Note[] | null;
  tax?: TaxItem[] | null;
  tax_thousands?: TaxThousand[] | null;
  fraudster?: boolean | null;
  investigation_barrier?: boolean | null;
  uc_interall?: string | null;
  date_of_birth?: string | null;
  prenup_text?: string | null;
  uc_internal_2?: any | null;
  parish?: string | null;
  parish_code?: string | null;
  blocked?: boolean | null;
  protected_address?: boolean | null;
  protected_identity?: boolean | null;
  marital_status_date?: string | null;
  minor?: string | null;
  lost_id_documents?: boolean | null;
  county?: string | null;
  county_code?: string | null;

  /** @format uuid */
  customer_id: string;
  credit_check?: CreditCheckSE | null;
  block_list?: BlockList | null;
  gender?: Gender | null;
}

export interface BlockList {
  pni?: boolean | null;
  phone_number?: boolean | null;
  email?: boolean | null;
}

export interface Cadastre {
  BNr?: number | null;
  FNr?: number | null;
  GNr?: number | null;
  KNr?: number | null;
  SNr?: number | null;
}

export interface CaseCollectionItem {
  uc_type_template_descition?: string | null;
  year?: string | null;
}

export interface Consents {
  email_marketing: boolean;
  sms_marketing: boolean;
  call_marketing?: boolean;
  customer_club_marketing: boolean;
}

export interface ConsentsPayload {
  customer_ids: string[];
}

/**
 * The type of contact, e.g. a phone number or an email address.
 */
export enum ContactType {
  Phone = "phone",
  Mail = "mail",
}

export enum Country {
  SE = "SE",
  NO = "NO",
}

export interface CreateApplicantNO {
  country?: string;
  pni: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: boolean | null;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  ev_estate?: EvEstate[] | null;
  ev_estates?: EvPropertyInput[] | null;
  citizenship_iso_codes?: string[] | null;
  externally_verified_credits?: ExternallyVerifiedCreditInput[] | null;
}

export interface CreateApplicantSE {
  country?: string;
  pni: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: any;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: OptionalEmployerSE | null;
  census_registration_year?: string | null;
  credit_regulation_information?: CreditRegulationInformation[] | null;
  credit_regulations?: CreditRegulation[] | null;
  case_collection?: CaseCollectionItem[] | null;
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  current_frame?: CurrentFrameItem[] | null;
  html?: string | null;
  last_queries?: LastQuery[] | null;
  notes?: Note[] | null;
  tax?: TaxItem[] | null;
  tax_thousands?: TaxThousand[] | null;
  fraudster?: boolean | null;
  investigation_barrier?: boolean | null;
  uc_interall?: string | null;
  date_of_birth?: string | null;
  prenup_text?: string | null;
  uc_internal_2?: any | null;
  parish?: string | null;
  parish_code?: string | null;
  blocked?: boolean | null;
  protected_address?: boolean | null;
  protected_identity?: boolean | null;
  marital_status_date?: string | null;
  minor?: string | null;
  lost_id_documents?: boolean | null;
  county?: string | null;
  county_code?: string | null;
}

export interface CreditCheckNO {
  earnedIncome: number;
  mostRecentNoteDate?: string | null;
  creditNotes?: number;
  expired?: boolean;
  expiration_date?: string | null;
  debt_equity_ratio?: number | null;
  debt_equtiy_year?: number | null;
  remarks?: Debt | null;
  cdg2_risk?: number | null;
  cdg2_score?: number | null;
}

export interface CreditCheckSE {
  earnedIncome: number;
  mostRecentNoteDate?: string | null;
  creditNotes?: number;
  expired?: boolean;
  expiration_date?: string | null;
  riskAssessment?: number | null;
  kfmDebt?: number;
  kfmDebtPublic?: number | null;
  kfmDebtPrivate?: number | null;
  numPrevious?: number;
  score?: number | null;
  inquiries?: number | null;
  issuers?: string[] | null;
}

export interface CreditRegulation {
  accounting_controlls_summary?: string | null;
  allow_casuation_storage?: string | null;
  cause_table?: string | null;
  risk?: string | null;
  risk_applicant?: string | null;
  risk_applicant_2?: string | null;
  template_description?: string | null;
  uc_internal_information?: string | null;
  year?: string | null;
}

export interface CreditRegulationInformation {
  account_number?: string | null;
  decision_template?: string | null;
  no_decimals?: string | null;
  order_template?: string | null;
  template_name?: string | null;
  template_response?: string | null;
  year?: string | null;
}

export enum Currency {
  EUR = "EUR",
  SEK = "SEK",
  NOK = "NOK",
}

export interface CurrentFrameItem {
  frame_information?: string | null;
  uc_divisions?: string | null;
  uc_post_type_current?: string | null;
  uc_quick_choice?: any | null;
  year?: string | null;
}

export interface CurrentSectionOfCaseItem {
  additional_order?: string | null;
  editor_program?: string | null;
  order_date?: string | null;
  person_name_stored?: string | null;
  report_language?: string | null;
  subscriber_name?: string | null;
  uc_archive?: string | null;
  uc_divisions_1?: string | null;
  uc_divisions_2?: string | null;
  uc_divisions_3?: string | null;
  uc_divisions_4?: string | null;
  uc_divisions_5?: string | null;
  uc_divisions_6?: string | null;
  uc_divisions_7?: string | null;
  uc_divisions_8?: string | null;
  uc_more_info?: string | null;
  uc_role?: string | null;
  uc_type?: string | null;
  uc_type_internal?: string | null;
  uc_type_text?: string | null;
  year?: string | null;
}

export interface CustomerConsents {
  customer_id: string;
  consents?: Consents | null;
}

export interface CustomerCreatePayload {
  reason: string;
  data: CreateApplicantSE | CreateApplicantNO | (CreateApplicantSE & CreateApplicantNO);

  /** Whether to perform an id check on the customer */
  id_check?: boolean;

  /** Whether to perform a credit check on the customer */
  credit_check?: boolean;

  /** Whether to perform a PEP check on the customer */
  pep_check?: boolean;

  /** Whether to perform a property check on the customer */
  property_check?: boolean;

  /** Whether to sync data from Sverker to KDLT first */
  sverker_sync?: boolean;

  /** Do not try to create/update customer if it already exists (but will do optional checks) */
  skip_if_already_exists?: boolean;
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

export interface CustomerDocument {
  /** Name of the document */
  name: string;

  /** MIME type of the document */
  mime_type: string;

  /** The type of document you're uploading, will be used as key on the customer */
  document_type: string;

  /**
   * ID of the customer to attach the document to
   * @format uuid
   */
  customer_id: string;

  /** Base64 encoded data of the document */
  data: string;

  /**
   * ID of the document
   * @format uuid
   */
  document_id: string;

  /**
   * Document creation time
   * @format date-time
   */
  timestamp: string;
}

export interface CustomerGetPayload {
  reason: string;

  /** ID of the customer */
  customer_id?: string | null;

  /** PNI of the customer */
  pni?: string | null;

  /** Country of the customer/customers */
  country?: Country | null;

  /** Whether to perform a credit check on the customer */
  credit_check?: boolean;

  /** Whether to perform an id check on the customer */
  id_check?: boolean;

  /** Whether to perform a PEP check on the customer */
  pep_check?: boolean;

  /** Whether to perform a property check on the customer */
  property_check?: boolean;

  /** First sync with the Sverker, and then get the data (can take a while!) */
  sverker_sync?: boolean;

  /** Try to get a customer and if doesn't exist, perform a Sverker sync */
  get_or_sverker_sync?: boolean;

  /** Get customer, if there is no customer do an ID check instead */
  get_or_id_check?: boolean;

  /** Force action id of the earlier response */
  force_action_event_id?: string | null;

  /** Timestamp of how the customer looked at this point in time */
  timestamp?: string | null;

  /** Metadata for the request made by the customer */
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

export interface CustomerHTTPRequestMetadata {
  ip?: string | null;
  url?: string | null;
  origin?: string | null;
  user_agent?: string | null;
  source?: MetadataSource;
  bankid?: Record<string, any> | null;
}

export interface CustomerIdWithDuplicateEmail {
  /** @format uuid */
  customer_id: string;
  other_customer_ids_with_same_email: string[];
}

export interface CustomerUpdatePayload {
  reason: string;
  data: UpdateApplicantSE | UpdateApplicantNO;

  /** Whether to perform a credit check on the customer */
  credit_check?: boolean;

  /** Whether to perform an id check on the customer */
  id_check?: boolean;

  /** Whether to perform a PEP check on the customer */
  pep_check?: boolean;

  /** Whether to perform a property check on the customer */
  property_check?: boolean;

  /** First sync with the Sverker, and then get the data (can take a while!) */
  sverker_sync?: boolean;

  /** Whether to create the customer if it does not exist */
  create_if_not_exists?: boolean;
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

export interface CustomersConsents {
  customers_consents?: CustomerConsents[];
}

export interface CustomersGetPayload {
  reason: string;

  /** IDs of the customers */
  customer_ids?: string[] | null;

  /** list of PNIs to search for */
  pnis?: string[] | null;

  /** Country of customers */
  country?: Country | null;

  /** Phone number of the customer */
  phone_numbers?: string[] | null;
  email?: string | null;

  /** Sverker ID of the customer */
  sverker_ids?: number[] | null;
}

export interface CustomersWithValidEmailsPayload {
  customer_ids?: string[];
  prospect_ids?: string[];
  reason: string;
}

export interface CustomersWithValidEmailsResponse {
  results: CustomersWithValidEmailsResponseModel[];
}

export interface CustomersWithValidEmailsResponseModel {
  customer_id?: string | null;
  prospect_id?: string | null;
  email_valid: boolean;
  verify_timestamp?: string | null;
  mandrill_response?: string | null;
  mandrill_response_timestamp?: string | null;
  description: string;
}

export interface Debt {
  debt?: DebtItem[] | null;
}

export interface DebtItem {
  date?: string | null;
  type?: string | null;
  source?: string | null;
  status?: string | null;
  saksnr?: string | null;
  amount?: number | null;
  oppgjort?: string | null;
  creditor?: string | null;
  art?: string | null;
  amount_percentage?: number | null;
  currency?: string | null;
  code?: string | null;
}

export interface DebtRegisterCreateConsent {
  /** PNI of the customer */
  pni: string;

  /** Country of the customer */
  country: Country;

  /** Metadata for the request */
  customer_http_request_metadata: CustomerHTTPRequestMetadata;

  /** Email of the customer */
  email?: string | null;

  /** Phone number of the customer */
  phone_number?: string | null;

  /** Marketing consents of the customer */
  marketing_consents?: Consents | null;
}

export interface DebtRegisterGetConsent {
  /** PNI of the customer */
  pni: string;

  /** Country of the customer */
  country: Country;

  /** Metadata for the request */
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

export interface DebtRegisterRenewConsent {
  /** PNI of the customer */
  pni?: string | null;

  /** ID of the customer */
  customer_id?: string | null;

  /** Metadata for the request */
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

export interface DocumentCreate {
  /** Name of the document */
  name: string;

  /** MIME type of the document */
  mime_type: string;

  /** The type of document you're uploading, will be used as key on the customer */
  document_type: string;

  /**
   * ID of the customer to attach the document to
   * @format uuid
   */
  customer_id: string;

  /** Base64 encoded data of the document */
  data: string;
}

export interface DocumentGetPayload {
  /**
   * Customer ID of the document owner
   * @format uuid
   */
  customer_id: string;

  /**
   * ID of the document
   * @format uuid
   */
  document_id: string;
}

export enum DocumentType {
  AMORTIZATION_PLAN = "AMORTIZATION_PLAN",
  PETITION_FOR_DIVORCE = "PETITION_FOR_DIVORCE",
  CERTIFICATE_OF_EMPLOYMENT = "CERTIFICATE_OF_EMPLOYMENT",
  DIVISION_OF_PROPERTY_AGREEMENT = "DIVISION_OF_PROPERTY_AGREEMENT",
  VERIFY_ESCROW_AGREEMENT = "VERIFY_ESCROW_AGREEMENT",
  FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION = "FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  PHYSICAL_MORTGAGE_DEEDS = "PHYSICAL_MORTGAGE_DEEDS",
  INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE = "INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE",
  DEED_OF_GIFT = "DEED_OF_GIFT",
  PURCHASE_AGREEMENT = "PURCHASE_AGREEMENT",
  CONTRACTORS_AGREEMENT = "CONTRACTORS_AGREEMENT",
  APARTMENT_CERTIFICATE = "APARTMENT_CERTIFICATE",
  COLLATERAL_OBJECT_DESCRIPTION = "COLLATERAL_OBJECT_DESCRIPTION",
  PENSION_PROJECTION = "PENSION_PROJECTION",
  PENSION_SPECIFICATION = "PENSION_SPECIFICATION",
  AUDITORS_CERTIFICATE = "AUDITORS_CERTIFICATE",
  LATESTAPPROVEDINCOMESTATEMENTANDNE3APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE3_APPENDIX",
  LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX",
  FINAL_INVOICE = "FINAL_INVOICE",
  SALES_AGREEMENT = "SALES_AGREEMENT",
  INFORMATION_TO_CONTACT_PERSON = "INFORMATION_TO_CONTACT_PERSON",
  TENURE_AGREEMENT = "TENURE_AGREEMENT",
  VALUATION = "VALUATION",
  VALUATION_OF_COMPLETED_PROPERTY = "VALUATION_OF_COMPLETED_PROPERTY",
  VALUATION_FROM_INDEPENDENT_BROKER = "VALUATION_FROM_INDEPENDENT_BROKER",
  TRANSFER_AGREEMENT = "TRANSFER_AGREEMENT",
  VALUATION_CERTIFICATE = "VALUATION_CERTIFICATE",
  CASH_DEPOSIT_DOCUMENTATION = "CASH_DEPOSIT_DOCUMENTATION",
  PRELIMINARY_SETTLEMENT_NOTE = "PRELIMINARY_SETTLEMENT_NOTE",
  ORIGINAL_BILL_OF_PURCHASE = "ORIGINAL_BILL_OF_PURCHASE",
  TITLE_DEED = "TITLE_DEED",
  FINAL_SERVEYING_PROTOCOL = "FINAL_SERVEYING_PROTOCOL",
  FINAL_CLEARANCE = "FINAL_CLEARANCE",
  INVOICES = "INVOICES",
  STATEMENT_OF_ACCOUNT = "STATEMENT_OF_ACCOUNT",
  PAYSLIP = "PAYSLIP",
  ANNUAL_REPORT_HOUSING_SOCIETY = "ANNUAL_REPORT_HOUSING_SOCIETY",
  ANNUAL_REPORT_SELF_EMPLOYED = "ANNUAL_REPORT_SELF_EMPLOYED",
  SPOUSE_CONSENT = "SPOUSE_CONSENT",
  OTHER_INCOME_CERTIFICATES = "OTHER_INCOME_CERTIFICATES",
  ESTATE_INVENTORY = "ESTATE_INVENTORY",
  LOAN_TERMS_OPTIONS = "LOAN_TERMS_OPTIONS",
  INSTRUMENT_OF_DEBT = "INSTRUMENT_OF_DEBT",
  KNOW_YOUR_CUSTOMER_QUESTIONS = "KNOW_YOUR_CUSTOMER_QUESTIONS",
  COPY_OF_IDENTIFICATION_CARD = "COPY_OF_IDENTIFICATION_CARD",
  INCOME_TAX_RETURN = "INCOME_TAX_RETURN",
  ENERGY_DECLARATION = "ENERGY_DECLARATION",
  OTHER = "OTHER",
}

export enum EducationType {
  ElementarySchool = "elementarySchool",
  HighSchool = "highSchool",
  Type1YearUniversity = "1yearUniversity",
  Type2YearsUniversity = "2yearsUniversity",
  Type3YearsUniversity = "3yearsUniversity",
  MoreThan3YearsUniversity = "moreThan3yearsUniversity",
}

export interface EmployerNO {
  name: string;
  type: EmploymentTypeNO;

  /** @format date */
  start_date: string;
  end_date?: string | null;
  phone?: string | null;
  retirement_age?: number | null;
  organization_number?: string | null;
  profession?: string | null;
}

export interface EmployerSE {
  name: string;
  type: EmploymentTypeSE;

  /** @format date */
  start_date: string;
  end_date?: string | null;
  phone?: string | null;
  retirement_age?: number | null;
  organization_number?: string | null;
  profession?: string | null;
}

export enum EmploymentTypeNO {
  Full = "full",
  SelfEmployed = "selfEmployed",
  Retired = "retired",
  TemporarilyDischarged = "temporarilyDischarged",
  Other = "other",
  Disabled = "disabled",
  Trial = "trial",
  Hourly = "hourly",
  Student = "student",
  NoWork = "noWork",
  StandIn = "standIn",
  Project = "project",
  NorwegianSickLeave = "norwegianSickLeave",
}

export enum EmploymentTypeSE {
  Full = "full",
  Trial = "trial",
  Retired = "retired",
  Hourly = "hourly",
  EarlyRetired = "earlyRetired",
  Project = "project",
  SelfEmployed = "selfEmployed",
  CompanyOwner = "companyOwner",
  NoWork = "noWork",
}

export interface EstateTypeType {
  Description?: string | null;
  Key?: string | null;
}

export interface EvCheckPayload {
  reason: string;
  pnis: string[];

  /** Metadata for the request */
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;

  /** Whether to perform the check asynchronously */
  do_async?: boolean;
}

export interface EvEstate {
  municipality?: string | null;
  municipality_number?: number | null;
  cadastralUnitNumber?: number | null;
  unitNumber?: number | null;
  leaseholdUnitNumber?: number | null;
  sectionNumber?: number | null;
  apartmentReference?: string | null;
  organizationNumber?: string | null;
  estimatedValue?: number | null;
  commonDebt?: number | null;
  estateType?: string | null;
  address?: EvEstateAddress | null;
}

export interface EvEstateAddress {
  streetName?: string | null;
  streetNumber?: number | null;
  streetLetter?: string | null;
  postCodeArea?: string | null;
  postCode?: string | null;
}

export interface EvPropertyInput {
  info: Info;
  mortgages?: Mortgage[] | null;
  value?: Value | null;
}

export interface EvPropertyOutput {
  info: Info;
  mortgages?: Mortgage[] | null;
  value?: Value | null;
}

export interface ExternalBlockCheckNO {
  email?: boolean | null;
  phone?: boolean | null;
  humanitarian?: boolean | null;
}

export interface ExternallyVerifiedCreditInput {
  /** Current balance of the credit excluding interest bearing and non-interest bearing balance.E.g for a blanco loan with a defined repayment time */
  balance?: number | null;
  creditType?: string | null;
  creditLimit?: number | null;
  currency?: Currency | null;
  dataOld?: boolean | null;
  financialInstitutionId?: string | null;
  financialInstitutionName?: string | null;
  gjeldsregisteret_type?: string | null;
  hasCoBorrower?: boolean | null;

  /** How often a charge occur. It is defined in Gjeldsregisteret documentation and api,however it is ALWAYS MONTHLY according to Gjeldsregisteret representatives... */
  installmentChargePeriod?: InstallmentChargePeriod | null;

  /** Monthly fees for the credit */
  installmentCharges?: number | null;

  /** Non-interest bearing balance of the credit, e.g for a credit card */
  nonInterestBearingBalance?: number | null;

  /** Interest bearing balance of the credit, e.g for a credit card */
  interestBearingBalance?: number | null;
  isCoBorrower?: boolean | null;
  nominalInterestRate?: number | null;

  /** Original balance of the credit when it was taken */
  originalBalance?: number | null;
  processedTime?: string | null;
  receivedTime?: string | null;

  /** Number of terms left for the credit */
  terms?: number | null;
}

export interface ExternallyVerifiedCreditOutput {
  /** Current balance of the credit excluding interest bearing and non-interest bearing balance.E.g for a blanco loan with a defined repayment time */
  balance?: number | null;
  creditType?: string | null;
  creditLimit?: number | null;
  currency?: Currency | null;
  dataOld?: boolean | null;
  financialInstitutionId?: string | null;
  financialInstitutionName?: string | null;
  gjeldsregisteret_type?: string | null;
  hasCoBorrower?: boolean | null;

  /** How often a charge occur. It is defined in Gjeldsregisteret documentation and api,however it is ALWAYS MONTHLY according to Gjeldsregisteret representatives... */
  installmentChargePeriod?: InstallmentChargePeriod | null;

  /** Monthly fees for the credit */
  installmentCharges?: number | null;

  /** Non-interest bearing balance of the credit, e.g for a credit card */
  nonInterestBearingBalance?: number | null;

  /** Interest bearing balance of the credit, e.g for a credit card */
  interestBearingBalance?: number | null;
  isCoBorrower?: boolean | null;
  nominalInterestRate?: number | null;

  /** Original balance of the credit when it was taken */
  originalBalance?: number | null;
  processedTime?: string | null;
  receivedTime?: string | null;

  /** Number of terms left for the credit */
  terms?: number | null;
  monthly_payment: number;
  total_debt: number;
}

export enum Gender {
  Male = "male",
  Female = "female",
  Other = "other",
}

export interface GetApplicantsWithDuplicateEmailsPayload {
  customer_ids: string[];
  reason: string;
}

export interface GetApplicantsWithDuplicateEmailsResponse {
  duplicate_email_customer_ids: CustomerIdWithDuplicateEmail[];
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface HousingCooperatativeShareIdentificationType {
  OrganizationNumber?: string | null;
  ShareNumber?: string | null;
}

export enum HousingTypeNO {
  RENTED = "RENTED",
  OWN_HOUSE = "OWN_HOUSE",
  PARENTS = "PARENTS",
  CONDOMINIUM = "CONDOMINIUM",
  OWN_APARTMENT = "OWN_APARTMENT",
}

export enum HousingTypeSE {
  RENTED = "RENTED",
  CONDOMINIUM = "CONDOMINIUM",
  LIVE_IN = "LIVE_IN",
  OWN_HOUSE = "OWN_HOUSE",
}

export interface IDCheckedPerson {
  country: Country;
  pni: string;
  first_name?: string | null;
  last_name?: string | null;
  street_address?: string | null;
  post_code?: string | null;
  city?: string | null;
  marital_status?: MaritalStatus | null;
  is_blocked?: boolean | null;
  age?: number | null;
  block_list?: BlockList | null;
}

export interface IdentityTypeType {
  Description?: string | null;
  Key?: string | null;
}

export interface ImportJobsPayload {
  /**
   * ID of the insertion job to get status for
   * @format uuid
   */
  insertion_id: string;

  /** Total number of jobs in the batch, used to calculate progress */
  total_jobs?: number | null;
}

export interface ImportJobsResponse {
  /**
   * ID of the insertion job to get status for
   * @format uuid
   */
  insertion_id: string;

  /** Results of the insertion job, contains number of inserted prospects */
  results?: Record<string, number> | null;

  /** Current status of the insertion job */
  status: ImportStatus;

  /** Number of inserted prospects */
  inserted_prospects?: number;
}

export enum ImportStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  PARTIALLY_FAILED = "PARTIALLY_FAILED",
  FAILED = "FAILED",
}

export interface Income {
  /**
   * Monthly amount
   * @min 0
   */
  amount?: number;

  /**
   * Yearly amount
   * @min 0
   */
  yearly_amount?: number;
  currency?: Currency | null;
  type: IncomeType;
  name: string;
}

export enum IncomeType {
  Rent = "rent",
  Other = "other",
  Employment = "employment",
  Partner = "partner",
}

export interface Info {
  Address: Address;
  Cadastre: Cadastre;
  EV_AddressID?: string | null;
  EV_EstateID?: string | null;
  HousingCooperatativeShareIdentification?: HousingCooperatativeShareIdentificationType | null;
}

export enum InstallmentChargePeriod {
  YEARLY = "YEARLY",
  QUARTERLY = "QUARTERLY",
  HALF_YEARLY = "HALF_YEARLY",
  MONTHLY = "MONTHLY",
}

export interface LastCreditCheckedApplicant {
  pni: string;

  /** @format date-time */
  last_credit_check: string;

  /** @format uuid */
  customer_id: string;
}

export interface LastCreditCheckedPayload {
  /** @format date-time */
  cutoff_date: string;
}

export interface LastQuery {
  issuer_business_type?: string | null;
  issuer_name?: string | null;
  query_date?: string | null;
  uc_internal_information?: string | null;
  year?: string | null;
}

export interface LegalDocumentTypeType {
  Description?: string | null;
  Key?: string | null;
}

export interface LienTypeType {
  Description?: string | null;
  Key?: string | null;
}

export interface MandrillResponsePayload {
  mandrill_response: string;

  /** @format uuid */
  customer_id: string;

  /** @format date-time */
  timestamp: string;
  reason: string;
}

export interface MandrillResponseResponse {
  /** @format uuid */
  customer_id: string;
  message_status_set: string;
}

export enum MaritalStatus {
  Unmarried = "unmarried",
  Married = "married",
  Divorced = "divorced",
  WidowWidower = "widow/widower",
  Deceased = "deceased",
  ChildUnder18Years = "child under 18 years",
  PreviouslyMarried = "previously married",
  RegisteredPartnership = "registered partnership",
  Partner = "partner",
}

export enum MetadataSource {
  GR_CONSENT = "GR_CONSENT",
  ONLINE_SUBMISSION_CONSENTS = "ONLINE_SUBMISSION_CONSENTS",
  MY_PAGES_CONSENTS = "MY_PAGES_CONSENTS",
  MY_PAGES_INSURANCE_TERMS_ACCEPTED = "MY_PAGES_INSURANCE_TERMS_ACCEPTED",
  OTHER = "OTHER",
}

export interface Mortgage {
  Document?: string | null;
  DocumentNumber?: string | null;
  DocumentYear?: string | null;
  IdentityName?: string | null;
  IdentityNumber?: string | null;
  IdentityType?: IdentityTypeType | null;
  IsRegisteredElectronically?: boolean | null;
  IsUncertain?: boolean | null;
  LegalDocumentNumber?: string | null;
  LegalDocumentType?: LegalDocumentTypeType | null;
  LienType?: LienTypeType | null;
  MortgageInfoAsText?: string | null;
  NumEstatesMortgageApplyTo?: string | null;
  OfficeNumber?: string | null;
  Priority?: string | null;
  RegisteredDate?: string | null;
  Share?: number | null;
  UncertainReason?: UncertainReasonType | null;
  Value?: number | null;
}

export interface Note {
  cause_description?: string | null;
  year?: string | null;
}

export interface OptionalApplicantNO {
  country?: string;
  pni?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: boolean | null;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  ev_estate?: EvEstate[] | null;
  ev_estates?: EvPropertyOutput[] | null;
  citizenship_iso_codes?: string[] | null;
  externally_verified_credits?: ExternallyVerifiedCreditOutput[] | null;
  customer_id?: string | null;
  credit_check?: CreditCheckNO | null;
  external_block_check?: ExternalBlockCheckNO | null;
}

export interface OptionalApplicantSE {
  country?: string;
  pni?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: any;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: OptionalEmployerSE | null;
  census_registration_year?: string | null;
  credit_regulation_information?: CreditRegulationInformation[] | null;
  credit_regulations?: CreditRegulation[] | null;
  case_collection?: CaseCollectionItem[] | null;
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  current_frame?: CurrentFrameItem[] | null;
  html?: string | null;
  last_queries?: LastQuery[] | null;
  notes?: Note[] | null;
  tax?: TaxItem[] | null;
  tax_thousands?: TaxThousand[] | null;
  fraudster?: boolean | null;
  investigation_barrier?: boolean | null;
  uc_interall?: string | null;
  date_of_birth?: string | null;
  prenup_text?: string | null;
  uc_internal_2?: any | null;
  parish?: string | null;
  parish_code?: string | null;
  blocked?: boolean | null;
  protected_address?: boolean | null;
  protected_identity?: boolean | null;
  marital_status_date?: string | null;
  minor?: string | null;
  lost_id_documents?: boolean | null;
  county?: string | null;
  county_code?: string | null;
  customer_id?: string | null;
  credit_check?: CreditCheckSE | null;
}

export interface OptionalEmployerNO {
  name?: string | null;
  type?: EmploymentTypeNO | null;
  start_date?: string | null;
  end_date?: string | null;
  phone?: string | null;
  retirement_age?: number | null;
  organization_number?: string | null;
  profession?: string | null;
}

export interface OptionalEmployerSE {
  name?: string | null;
  type?: EmploymentTypeSE | null;
  start_date?: string | null;
  end_date?: string | null;
  phone?: string | null;
  retirement_age?: number | null;
  organization_number?: string | null;
  profession?: string | null;
}

export interface PersonGetPayload {
  reason: string;

  /** PNI of the customer */
  pni: string;

  /** Country of the customer/customers */
  country?: Country | null;

  /** Whether to perform a PEP check on the customer */
  pep_check?: boolean;
}

export interface PersonsGetPayload {
  reason: string;

  /** Cutomers PNIs */
  pnis: string[];

  /** Country of the customer/customers */
  country?: Country | null;

  /** Whether to perform a PEP check on the customer */
  pep_check?: boolean;
}

export interface PhoneNumber {
  number: string;
  type: PhoneNumberType;
}

export enum PhoneNumberType {
  Home = "home",
  Day = "day",
  Work = "work",
  Other = "other",
}

export interface Phones2IdsPayload {
  phones: string[];

  /** All phone numbers are from this country */
  country?: Country | null;
}

export interface Pni2IdPayload {
  pnis: string[];
}

/**
* Aggregated prospect model used to store information from all events gathered for given phone or email.
Prospects are our main data model for storing information about potential customers which will be used further in
dialmaker or mailmaker campaigns .
*/
export interface Prospect {
  /** Prospect data model used to store just personal contact information, either phone or email must be present. */
  data: ProspectData;
  consents?: Consents | null;
  tags?: string[];
  source?: ProspectSource | null;
  country?: Country | null;
  abandoned_form_id?: string | null;
  contact_type?: ContactType | null;

  /** If specified prospect will not be used afterwards and will be anonymized */
  valid_until?: string | null;

  /** @format uuid */
  id: string;
  soft_linked_customer_ids?: string[] | null;
  hard_linked_customer_id?: string | null;
  sources?: ProspectSource[];

  /** @format date-time */
  created_at: string;
  updated_at?: string | null;
}

/**
 * Used for sending prospects to KDLT. It contains all the information needed to create a prospect in KDLT.
 */
export interface ProspectBase {
  /** Prospect data model used to store just personal contact information, either phone or email must be present. */
  data: ProspectData;
  consents?: Consents | null;
  tags?: string[];
  source?: ProspectSource | null;
  country?: Country | null;
  abandoned_form_id?: string | null;
  contact_type?: ContactType | null;

  /** If specified prospect will not be used afterwards and will be anonymized */
  valid_until?: string | null;
}

/**
 * Prospect data model used to store just personal contact information, either phone or email must be present.
 */
export interface ProspectData {
  phone?: string | null;
  email?: string | null;
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  gender?: Gender | null;
  date_of_birth?: string | null;
  street_address?: string | null;
  post_code?: string | null;
  city?: string | null;
  country?: Country | null;
  housing_type?: HousingTypeNO | HousingTypeSE | null | (HousingTypeNO & HousingTypeSE);
  current_bank?: string | null;
  got_loans?: boolean | null;
  loan_sum?: number | null;
  got_car?: boolean | null;
}

/**
 * Prospect metadata model used to store additional information about the prospect.
 */
export interface ProspectMetadata {
  ip?: string | null;
  url?: string | null;
  origin?: string | null;
  user_agent?: string | null;
  source_file_name?: string | null;
  prospect_cost?: number | null;
}

/**
 * Source of the prospect, e.g. a form submission, an import, etc. Aggregated prospect can have multiple sources.
 */
export interface ProspectSource {
  /** The source of the prospect, e.g. a form submission, an import, etc. */
  source: SourceType;

  /** Prospect metadata model used to store additional information about the prospect. */
  metadata?: ProspectMetadata;

  /** @format date-time */
  timestamp?: string;
}

/**
 * anonymize prospects with consent for given contact older than given days
 */
export interface ProspectsAnonymizePayload {
  online_date?: string | null;
  file_date?: string | null;
  subscription_date?: string | null;
  external_endpoint_date?: string | null;
}

/**
 * Response for prospects anonymize
 */
export interface ProspectsAnonymizeResponse {
  /** @format uuid */
  anonymization_id: string;
  total_prospects_to_anonymize: number;
  abandoned_forms_ids: string[];
}

export interface ProspectsGetPayload {
  search: string[];
}

/**
* Upsertion payload, either prospects_base or prospects_data must be present, not both.
If prospects_data is present, then common for all prospects source, tags, country and consents must also be present.
*/
export interface ProspectsUpsertPayload {
  prospects_base?: ProspectBase[] | null;
  prospects_data?: ProspectData[] | null;
  prospect_source?: ProspectSource | null;
  consents?: Consents | null;
  tags?: string[] | null;
  country?: Country | null;
  valid_until?: string | null;
}

export interface ProspectsUpsertResponse {
  /** List of already upserted prospects */
  prospects: Prospect[];
  insertion_jobs_finished: number;
  insertion_jobs_failed: number;
  insertion_jobs_pending: number;
  insertion_jobs_total: number;

  /**
   * ID of the insertion
   * @format uuid
   */
  insertion_id: string;

  /** Results of the insertion job, contains number of inserted prospects */
  results?: Record<string, number> | null;

  /** Total number of prospects */
  total?: number | null;
}

/**
 * The source of the prospect, e.g. a form submission, an import, etc.
 */
export enum SourceType {
  Online = "online",
  File = "file",
  EmailSubscription = "email_subscription",
  ExternalSource = "external_source",
}

export interface StatusType {
  Description?: string | null;
  Key?: string | null;
}

export interface TagsDeletePayload {
  tags: string[];
}

export interface TagsInsertPayload {
  tags: string[];
}

export interface TaxItem {
  assessed_income?: string | null;
  assessed_wages?: string | null;
  capital_gains?: string | null;
  final_tax?: string | null;
  income_year?: string | null;
  remaining_tax?: string | null;
  total_income?: string | null;
  year?: string | null;
}

export interface TaxThousand {
  assessed_income_thousand?: string | null;
  assessed_wages_thousand?: string | null;
  capital_gains_thousand?: string | null;
  final_tax_thousand?: string | null;
  income_year?: string | null;
  remaining_tax_thousand?: string | null;
  taxed_income?: string | null;
  year?: string | null;
}

export interface UncertainReasonType {
  Description?: string | null;
  Key?: string | null;
}

export interface UpdateApplicantNO {
  country?: string;
  pni?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: boolean | null;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  ev_estate?: EvEstate[] | null;
  ev_estates?: EvPropertyInput[] | null;
  citizenship_iso_codes?: string[] | null;
  externally_verified_credits?: ExternallyVerifiedCreditInput[] | null;
  customer_id?: string | null;
}

export interface UpdateApplicantSE {
  country?: string;
  pni?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  additional_phone_numbers?: string[] | null;
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;

  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  post_code?: string | null;
  city?: string | null;
  incomes?: Income[] | null;
  net_monthly_income?: number | null;
  account?: Account | null;
  street_address?: string | null;

  /** Number of children to pay child support for */
  paying_child_support?: number | null;

  /** Number of children to receive child support for */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  consents_popup_dismissed_timestamp?: string | null;
  partner_pni?: string | null;
  partner_name?: string | null;
  municipality_code?: string | null;
  municipality?: string | null;
  is_pep?: boolean | null;
  age?: number | null;
  other_phones?: PhoneNumber[] | null;
  sverker_id?: number | null;
  children?: number | null;
  citizen?: number | null;
  education?: EducationType | null;
  monthly_partner_income?: number | null;
  immigrated_at?: string | null;
  fullname?: string | null;
  documents?: ApplicantDocument[] | null;
  verified_credits?: boolean | null;
  housing_since?: string | null;
  deceased?: boolean | null;
  deceased_date?: string | null;
  emigrated?: boolean | null;
  is_sanction?: boolean | null;
  is_rca?: boolean | null;
  date_created?: string | null;
  date_updated?: string | null;
  last_credit_check?: string | null;
  last_externally_verified_credits?: string | null;
  last_property_valuation?: string | null;
  pep_quality?: any;

  /** A cluster is a group of customers displayed with a color */
  cluster?: string | null;

  /** Indicates if the customer is blocked */
  is_blocked?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: OptionalEmployerSE | null;
  census_registration_year?: string | null;
  credit_regulation_information?: CreditRegulationInformation[] | null;
  credit_regulations?: CreditRegulation[] | null;
  case_collection?: CaseCollectionItem[] | null;
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  current_frame?: CurrentFrameItem[] | null;
  html?: string | null;
  last_queries?: LastQuery[] | null;
  notes?: Note[] | null;
  tax?: TaxItem[] | null;
  tax_thousands?: TaxThousand[] | null;
  fraudster?: boolean | null;
  investigation_barrier?: boolean | null;
  uc_interall?: string | null;
  date_of_birth?: string | null;
  prenup_text?: string | null;
  uc_internal_2?: any | null;
  parish?: string | null;
  parish_code?: string | null;
  blocked?: boolean | null;
  protected_address?: boolean | null;
  protected_identity?: boolean | null;
  marital_status_date?: string | null;
  minor?: string | null;
  lost_id_documents?: boolean | null;
  county?: string | null;
  county_code?: string | null;
  customer_id?: string | null;
}

export interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}

export interface Value {
  AccuracyLevel?: string | null;
  AreaMarketScore?: number | null;
  AreaVacationHomeMarketScore?: string | null;
  CustomerApprovedValue?: string | null;
  CustomerMaxValue?: string | null;
  EstateType?: EstateTypeType | null;
  Estimate?: number | null;
  EstimateHaircut?: string | null;
  GrossValueEstimate?: string | null;
  HaircutPercentage?: string | null;
  LastKnownCommondebt?: number | null;
  LastKnownCommondebtDate?: string | null;
  MunicipalityScore?: number | null;
  NetValueEstimate?: number | null;
  Status?: StatusType | null;
  StoredEstimateDocumentationId?: string | null;
}

export interface VerifyCustomersEmailsPayload {
  customer_ids?: string[];
  emails?: string[];
  prospect_ids?: string[];
  do_async?: boolean;
  reason: string;
  run_new_check?: boolean;
}

export interface VerifyCustomersEmailsResponse {
  results?: VerifyCustomersEmailsResponseModel[];
  job_id?: string | null;
}

export interface VerifyCustomersEmailsResponseModel {
  email: string;
  email_valid?: boolean | null;
  verify_result?: string | null;
  verify_timestamp?: string | null;
  mandrill_response?: string | null;
  mandrill_response_timestamp?: string | null;
}

export namespace Health {
  /**
   * No description
   * @name GetHealthHealthGet
   * @summary Get Health
   * @request GET:/health
   */
  export namespace GetHealthHealthGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Api {
  /**
   * No description
   * @name GetHealthApiV2HealthGet
   * @summary Get Health
   * @request GET:/api/v2/health
   */
  export namespace GetHealthApiV2HealthGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
  /**
   * No description
   * @name VerifyCustomersEmailsApiV2VerifyCustomersEmailsPost
   * @summary Verify Customers Emails
   * @request POST:/api/v2/verify-customers-emails
   * @secure
   */
  export namespace VerifyCustomersEmailsApiV2VerifyCustomersEmailsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VerifyCustomersEmailsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = VerifyCustomersEmailsResponse;
  }
  /**
   * No description
   * @name GetCustomersOrProspectsWithValidEmailsApiV2ValidEmailsPost
   * @summary Get Customers Or Prospects With Valid Emails
   * @request POST:/api/v2/valid-emails
   * @secure
   */
  export namespace GetCustomersOrProspectsWithValidEmailsApiV2ValidEmailsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomersWithValidEmailsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CustomersWithValidEmailsResponse;
  }
  /**
   * No description
   * @name SaveMandrillResponseApiV2MandrillResponsePost
   * @summary Save Mandrill Response
   * @request POST:/api/v2/mandrill-response
   */
  export namespace SaveMandrillResponseApiV2MandrillResponsePost {
    export type RequestParams = {};
    export type RequestQuery = { log_unset?: boolean };
    export type RequestBody = MandrillResponsePayload;
    export type RequestHeaders = {};
    export type ResponseBody = MandrillResponseResponse;
  }
  /**
   * No description
   * @name GetDuplicateEmailsApiV2DuplicateEmailsPost
   * @summary Get Duplicate Emails
   * @request POST:/api/v2/duplicate-emails
   */
  export namespace GetDuplicateEmailsApiV2DuplicateEmailsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicantsWithDuplicateEmailsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = GetApplicantsWithDuplicateEmailsResponse;
  }
  /**
   * @description Returns customer ids for given pnis (dict: pni -> customer_id)
   * @name ApiPnisToIdsApiV2PnisToIdsPost
   * @summary Api Pnis To Ids
   * @request POST:/api/v2/pnis-to-ids
   * @secure
   */
  export namespace ApiPnisToIdsApiV2PnisToIdsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Pni2IdPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, string>;
  }
  /**
   * @description Returns customer ids for given phones (dict: phones -> customer_id)
   * @name ApiPhonesToIdsApiV2PhonesToIdsPost
   * @summary Api Phones To Ids
   * @request POST:/api/v2/phones-to-ids
   * @secure
   */
  export namespace ApiPhonesToIdsApiV2PhonesToIdsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Phones2IdsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, string[]>;
  }
  /**
   * @description Returns (one) customer by PNI or customer_id. Allows performing checks (id, credit, pep, property) and sverker sync.
   * @name ApiCustomerGetApiV2CustomerGetPost
   * @summary Api Customer Get
   * @request POST:/api/v2/customer-get
   * @secure
   */
  export namespace ApiCustomerGetApiV2CustomerGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomerGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | IDCheckedPerson
      | null
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO) & IDCheckedPerson);
  }
  /**
   * @description Returns a list of customers by PNIs, customer_ids, phone number, sverker_id, sverker_ids, email. Does not allow performing any external checks (id check etc.).
   * @name ApiCustomersGetApiV2CustomersGetPost
   * @summary Api Customers Get
   * @request POST:/api/v2/customers-get
   * @secure
   */
  export namespace ApiCustomersGetApiV2CustomersGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomersGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | IDCheckedPerson
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO) & IDCheckedPerson)
    )[];
  }
  /**
   * @description Returns an IDCheckedPerson object or None for given PNI (it's an old lookup_by_pni endpoint) Allows to perform a PEP check.
   * @name ApiPersonGetApiV2PersonGetPost
   * @summary Api Person Get
   * @request POST:/api/v2/person-get
   * @secure
   */
  export namespace ApiPersonGetApiV2PersonGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PersonGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = IDCheckedPerson | null;
  }
  /**
   * @description Returns a list of IDCheckedPerson object for given PNIs (it's an old lookup_by_pnis endpoint). Allows performing a PEP check.
   * @name ApiPersonsGetApiV2PersonsGetPost
   * @summary Api Persons Get
   * @request POST:/api/v2/persons-get
   * @secure
   */
  export namespace ApiPersonsGetApiV2PersonsGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PersonsGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = IDCheckedPerson[];
  }
  /**
   * @description Creates a new customer. Allows performing: - id check - credit check - pep check - property check Returns an ApplicantCountry or OptionalApplicantCountry object.
   * @name ApiCustomerCreateApiV2CustomerCreatePost
   * @summary Api Customer Create
   * @request POST:/api/v2/customer-create
   * @secure
   */
  export namespace ApiCustomerCreateApiV2CustomerCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomerCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO));
  }
  /**
   * @description Update an existing customer (or create a new one if it does not exist when create_if_not_exists=True). Allows performing: - id check - credit check - pep check - property check Returns an ApplicantCountry or OptionalApplicantCountry object.
   * @name ApiCustomerUpdateApiV2CustomerUpdatePost
   * @summary Api Customer Update
   * @request POST:/api/v2/customer-update
   * @secure
   */
  export namespace ApiCustomerUpdateApiV2CustomerUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomerUpdatePayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO));
  }
  /**
   * @description Returns property valuation check for given pnis (dict: pni -> list of EvProperty) If we have a current check, it will be returned, otherwise a new one will be done.
   * @name ApiEvCheckApiV2EvChecksPost
   * @summary Api Ev Check
   * @request POST:/api/v2/ev-checks
   * @secure
   */
  export namespace ApiEvCheckApiV2EvChecksPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = EvCheckPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, EvPropertyOutput[]>;
  }
  /**
   * @description Returns a list of LastCreditCheckedApplicant objects for given cutoff_date.
   * @name ApiLastCreditCheckedCustomerApiV2LastCreditCheckedCustomerPost
   * @summary Api Last Credit Checked Customer
   * @request POST:/api/v2/last-credit-checked-customer
   * @secure
   */
  export namespace ApiLastCreditCheckedCustomerApiV2LastCreditCheckedCustomerPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LastCreditCheckedPayload;
    export type RequestHeaders = {};
    export type ResponseBody = LastCreditCheckedApplicant[];
  }
  /**
   * No description
   * @name GetCustomersConsentsApiV2ConsentsPost
   * @summary Get Customers Consents
   * @request POST:/api/v2/consents
   * @secure
   */
  export namespace GetCustomersConsentsApiV2ConsentsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConsentsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CustomersConsents;
  }
  /**
   * @description Give consent for Zensum to fetch debt register data
   * @name ApiDebtRegisterCreateConsentApiV2DebtRegisterConsentPost
   * @summary Api Debt Register Create Consent
   * @request POST:/api/v2/debt-register/consent
   * @secure
   */
  export namespace ApiDebtRegisterCreateConsentApiV2DebtRegisterConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DebtRegisterCreateConsent;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO));
  }
  /**
   * No description
   * @name ApiDebtRegisterGetConsentApiV2DebtRegisterGetPost
   * @summary Api Debt Register Get Consent
   * @request POST:/api/v2/debt-register/get
   * @secure
   */
  export namespace ApiDebtRegisterGetConsentApiV2DebtRegisterGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DebtRegisterGetConsent;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO));
  }
  /**
   * No description
   * @name ApiDebtRegisterRenewConsentApiV2DebtRegisterRenewPost
   * @summary Api Debt Register Renew Consent
   * @request POST:/api/v2/debt-register/renew
   * @secure
   */
  export namespace ApiDebtRegisterRenewConsentApiV2DebtRegisterRenewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DebtRegisterRenewConsent;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (ApplicantSE | ApplicantNO)
      | (OptionalApplicantSE | OptionalApplicantNO)
      | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO));
  }
  /**
   * No description
   * @name ApiDocumentCreateApiV2DocumentCreatePost
   * @summary Api Document Create
   * @request POST:/api/v2/document/create
   * @secure
   */
  export namespace ApiDocumentCreateApiV2DocumentCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentCreate;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }
  /**
   * No description
   * @name ApiDocumentGetApiV2DocumentGetPost
   * @summary Api Document Get
   * @request POST:/api/v2/document/get
   * @secure
   */
  export namespace ApiDocumentGetApiV2DocumentGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }
  /**
   * No description
   * @name ApiDocumentGetMetaApiV2DocumentMetaPost
   * @summary Api Document Get Meta
   * @request POST:/api/v2/document/meta
   * @secure
   */
  export namespace ApiDocumentGetMetaApiV2DocumentMetaPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }
  /**
   * @description Create or update a prospect.
   * @name UpsertProspectApiV2ProspectsUpsertPost
   * @summary Upsert Prospect
   * @request POST:/api/v2/prospects/upsert
   * @secure
   */
  export namespace UpsertProspectApiV2ProspectsUpsertPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ProspectsUpsertPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ProspectsUpsertResponse;
  }
  /**
   * @description Get the status of insertion jobs.
   * @name GetInsertionJobStatusApiV2ProspectsImportStatusPost
   * @summary Get Insertion Job Status
   * @request POST:/api/v2/prospects/import_status
   * @secure
   */
  export namespace GetInsertionJobStatusApiV2ProspectsImportStatusPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ImportJobsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ImportJobsResponse;
  }
  /**
   * @description Get a prospect by search strings, can be phone, email, id, tags
   * @name GetProspectApiV2ProspectsGetPost
   * @summary Get Prospect
   * @request POST:/api/v2/prospects/get
   * @secure
   */
  export namespace GetProspectApiV2ProspectsGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ProspectsGetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Prospect[];
  }
  /**
   * @description Get all existing tags.
   * @name GetTagsApiV2ProspectsTagsGet
   * @summary Get Tags
   * @request GET:/api/v2/prospects/tags
   * @secure
   */
  export namespace GetTagsApiV2ProspectsTagsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }
  /**
   * @description Insert new tags, return tags which were inserted.
   * @name InsertTagApiV2ProspectsTagsPost
   * @summary Insert Tag
   * @request POST:/api/v2/prospects/tags
   * @secure
   */
  export namespace InsertTagApiV2ProspectsTagsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TagsInsertPayload;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }
  /**
   * @description Delete tags, return tags which left after deletion.
   * @name DeleteTagsApiV2ProspectsTagsDelete
   * @summary Delete Tags
   * @request DELETE:/api/v2/prospects/tags
   * @secure
   */
  export namespace DeleteTagsApiV2ProspectsTagsDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TagsDeletePayload;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }
  /**
   * @description Anonymize a prospect by id.
   * @name AnonymizeProspectsApiV2ProspectsAnonymizePost
   * @summary Anonymize Prospects
   * @request POST:/api/v2/prospects/anonymize
   * @secure
   */
  export namespace AnonymizeProspectsApiV2ProspectsAnonymizePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ProspectsAnonymizePayload;
    export type RequestHeaders = {};
    export type ResponseBody = ProspectsAnonymizeResponse;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends globalThis.Response {
  data: D;
  error: E;
  requestId: string;
}

export interface HttpErrorResponse<E> extends globalThis.Response {
  error: E;
  requestId: string;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "include",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  private generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    // We need to generate new RequestID for every request
    let requestId = requestParams.headers["X-Request-ID"];
    if (!requestId) {
      requestId = this.generateUUID();
      requestParams.headers["X-Request-ID"] = requestId;
    }

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;
      r.requestId = requestId;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data as HttpErrorResponse<E>;
      return data;
    });
  };
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * No description
     *
     * @name GetHealthHealthGet
     * @summary Get Health
     * @request GET:/health
     */
    getHealthHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @name GetHealthApiV2HealthGet
     * @summary Get Health
     * @request GET:/api/v2/health
     */
    getHealthApiV2HealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v2/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VerifyCustomersEmailsApiV2VerifyCustomersEmailsPost
     * @summary Verify Customers Emails
     * @request POST:/api/v2/verify-customers-emails
     * @secure
     */
    verifyCustomersEmailsApiV2VerifyCustomersEmailsPost: (
      data: VerifyCustomersEmailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<VerifyCustomersEmailsResponse, HTTPValidationError>({
        path: `/api/v2/verify-customers-emails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomersOrProspectsWithValidEmailsApiV2ValidEmailsPost
     * @summary Get Customers Or Prospects With Valid Emails
     * @request POST:/api/v2/valid-emails
     * @secure
     */
    getCustomersOrProspectsWithValidEmailsApiV2ValidEmailsPost: (
      data: CustomersWithValidEmailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CustomersWithValidEmailsResponse, HTTPValidationError>({
        path: `/api/v2/valid-emails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SaveMandrillResponseApiV2MandrillResponsePost
     * @summary Save Mandrill Response
     * @request POST:/api/v2/mandrill-response
     */
    saveMandrillResponseApiV2MandrillResponsePost: (
      data: MandrillResponsePayload,
      query?: { log_unset?: boolean },
      params: RequestParams = {},
    ) =>
      this.request<MandrillResponseResponse, HTTPValidationError>({
        path: `/api/v2/mandrill-response`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDuplicateEmailsApiV2DuplicateEmailsPost
     * @summary Get Duplicate Emails
     * @request POST:/api/v2/duplicate-emails
     */
    getDuplicateEmailsApiV2DuplicateEmailsPost: (
      data: GetApplicantsWithDuplicateEmailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicantsWithDuplicateEmailsResponse, HTTPValidationError>({
        path: `/api/v2/duplicate-emails`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns customer ids for given pnis (dict: pni -> customer_id)
     *
     * @name ApiPnisToIdsApiV2PnisToIdsPost
     * @summary Api Pnis To Ids
     * @request POST:/api/v2/pnis-to-ids
     * @secure
     */
    apiPnisToIdsApiV2PnisToIdsPost: (data: Pni2IdPayload, params: RequestParams = {}) =>
      this.request<Record<string, string>, HTTPValidationError>({
        path: `/api/v2/pnis-to-ids`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns customer ids for given phones (dict: phones -> customer_id)
     *
     * @name ApiPhonesToIdsApiV2PhonesToIdsPost
     * @summary Api Phones To Ids
     * @request POST:/api/v2/phones-to-ids
     * @secure
     */
    apiPhonesToIdsApiV2PhonesToIdsPost: (data: Phones2IdsPayload, params: RequestParams = {}) =>
      this.request<Record<string, string[]>, HTTPValidationError>({
        path: `/api/v2/phones-to-ids`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns (one) customer by PNI or customer_id. Allows performing checks (id, credit, pep, property) and sverker sync.
     *
     * @name ApiCustomerGetApiV2CustomerGetPost
     * @summary Api Customer Get
     * @request POST:/api/v2/customer-get
     * @secure
     */
    apiCustomerGetApiV2CustomerGetPost: (data: CustomerGetPayload, params: RequestParams = {}) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | IDCheckedPerson
        | null
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO) & IDCheckedPerson),
        HTTPValidationError
      >({
        path: `/api/v2/customer-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of customers by PNIs, customer_ids, phone number, sverker_id, sverker_ids, email. Does not allow performing any external checks (id check etc.).
     *
     * @name ApiCustomersGetApiV2CustomersGetPost
     * @summary Api Customers Get
     * @request POST:/api/v2/customers-get
     * @secure
     */
    apiCustomersGetApiV2CustomersGetPost: (data: CustomersGetPayload, params: RequestParams = {}) =>
      this.request<
        (
          | (ApplicantSE | ApplicantNO)
          | (OptionalApplicantSE | OptionalApplicantNO)
          | IDCheckedPerson
          | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO) & IDCheckedPerson)
        )[],
        HTTPValidationError
      >({
        path: `/api/v2/customers-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns an IDCheckedPerson object or None for given PNI (it's an old lookup_by_pni endpoint) Allows to perform a PEP check.
     *
     * @name ApiPersonGetApiV2PersonGetPost
     * @summary Api Person Get
     * @request POST:/api/v2/person-get
     * @secure
     */
    apiPersonGetApiV2PersonGetPost: (data: PersonGetPayload, params: RequestParams = {}) =>
      this.request<IDCheckedPerson | null, HTTPValidationError>({
        path: `/api/v2/person-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of IDCheckedPerson object for given PNIs (it's an old lookup_by_pnis endpoint). Allows performing a PEP check.
     *
     * @name ApiPersonsGetApiV2PersonsGetPost
     * @summary Api Persons Get
     * @request POST:/api/v2/persons-get
     * @secure
     */
    apiPersonsGetApiV2PersonsGetPost: (data: PersonsGetPayload, params: RequestParams = {}) =>
      this.request<IDCheckedPerson[], HTTPValidationError>({
        path: `/api/v2/persons-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new customer. Allows performing: - id check - credit check - pep check - property check Returns an ApplicantCountry or OptionalApplicantCountry object.
     *
     * @name ApiCustomerCreateApiV2CustomerCreatePost
     * @summary Api Customer Create
     * @request POST:/api/v2/customer-create
     * @secure
     */
    apiCustomerCreateApiV2CustomerCreatePost: (data: CustomerCreatePayload, params: RequestParams = {}) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO)),
        HTTPValidationError
      >({
        path: `/api/v2/customer-create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing customer (or create a new one if it does not exist when create_if_not_exists=True). Allows performing: - id check - credit check - pep check - property check Returns an ApplicantCountry or OptionalApplicantCountry object.
     *
     * @name ApiCustomerUpdateApiV2CustomerUpdatePost
     * @summary Api Customer Update
     * @request POST:/api/v2/customer-update
     * @secure
     */
    apiCustomerUpdateApiV2CustomerUpdatePost: (data: CustomerUpdatePayload, params: RequestParams = {}) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO)),
        HTTPValidationError
      >({
        path: `/api/v2/customer-update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns property valuation check for given pnis (dict: pni -> list of EvProperty) If we have a current check, it will be returned, otherwise a new one will be done.
     *
     * @name ApiEvCheckApiV2EvChecksPost
     * @summary Api Ev Check
     * @request POST:/api/v2/ev-checks
     * @secure
     */
    apiEvCheckApiV2EvChecksPost: (data: EvCheckPayload, params: RequestParams = {}) =>
      this.request<Record<string, EvPropertyOutput[]>, HTTPValidationError>({
        path: `/api/v2/ev-checks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of LastCreditCheckedApplicant objects for given cutoff_date.
     *
     * @name ApiLastCreditCheckedCustomerApiV2LastCreditCheckedCustomerPost
     * @summary Api Last Credit Checked Customer
     * @request POST:/api/v2/last-credit-checked-customer
     * @secure
     */
    apiLastCreditCheckedCustomerApiV2LastCreditCheckedCustomerPost: (
      data: LastCreditCheckedPayload,
      params: RequestParams = {},
    ) =>
      this.request<LastCreditCheckedApplicant[], HTTPValidationError>({
        path: `/api/v2/last-credit-checked-customer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCustomersConsentsApiV2ConsentsPost
     * @summary Get Customers Consents
     * @request POST:/api/v2/consents
     * @secure
     */
    getCustomersConsentsApiV2ConsentsPost: (data: ConsentsPayload, params: RequestParams = {}) =>
      this.request<CustomersConsents, HTTPValidationError>({
        path: `/api/v2/consents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Give consent for Zensum to fetch debt register data
     *
     * @name ApiDebtRegisterCreateConsentApiV2DebtRegisterConsentPost
     * @summary Api Debt Register Create Consent
     * @request POST:/api/v2/debt-register/consent
     * @secure
     */
    apiDebtRegisterCreateConsentApiV2DebtRegisterConsentPost: (
      data: DebtRegisterCreateConsent,
      params: RequestParams = {},
    ) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO)),
        HTTPValidationError
      >({
        path: `/api/v2/debt-register/consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ApiDebtRegisterGetConsentApiV2DebtRegisterGetPost
     * @summary Api Debt Register Get Consent
     * @request POST:/api/v2/debt-register/get
     * @secure
     */
    apiDebtRegisterGetConsentApiV2DebtRegisterGetPost: (data: DebtRegisterGetConsent, params: RequestParams = {}) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO)),
        HTTPValidationError
      >({
        path: `/api/v2/debt-register/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ApiDebtRegisterRenewConsentApiV2DebtRegisterRenewPost
     * @summary Api Debt Register Renew Consent
     * @request POST:/api/v2/debt-register/renew
     * @secure
     */
    apiDebtRegisterRenewConsentApiV2DebtRegisterRenewPost: (
      data: DebtRegisterRenewConsent,
      params: RequestParams = {},
    ) =>
      this.request<
        | (ApplicantSE | ApplicantNO)
        | (OptionalApplicantSE | OptionalApplicantNO)
        | ((ApplicantSE | ApplicantNO) & (OptionalApplicantSE | OptionalApplicantNO)),
        HTTPValidationError
      >({
        path: `/api/v2/debt-register/renew`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ApiDocumentCreateApiV2DocumentCreatePost
     * @summary Api Document Create
     * @request POST:/api/v2/document/create
     * @secure
     */
    apiDocumentCreateApiV2DocumentCreatePost: (data: DocumentCreate, params: RequestParams = {}) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/api/v2/document/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ApiDocumentGetApiV2DocumentGetPost
     * @summary Api Document Get
     * @request POST:/api/v2/document/get
     * @secure
     */
    apiDocumentGetApiV2DocumentGetPost: (data: DocumentGetPayload, params: RequestParams = {}) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/api/v2/document/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ApiDocumentGetMetaApiV2DocumentMetaPost
     * @summary Api Document Get Meta
     * @request POST:/api/v2/document/meta
     * @secure
     */
    apiDocumentGetMetaApiV2DocumentMetaPost: (data: DocumentGetPayload, params: RequestParams = {}) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/api/v2/document/meta`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or update a prospect.
     *
     * @name UpsertProspectApiV2ProspectsUpsertPost
     * @summary Upsert Prospect
     * @request POST:/api/v2/prospects/upsert
     * @secure
     */
    upsertProspectApiV2ProspectsUpsertPost: (data: ProspectsUpsertPayload, params: RequestParams = {}) =>
      this.request<ProspectsUpsertResponse, HTTPValidationError>({
        path: `/api/v2/prospects/upsert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the status of insertion jobs.
     *
     * @name GetInsertionJobStatusApiV2ProspectsImportStatusPost
     * @summary Get Insertion Job Status
     * @request POST:/api/v2/prospects/import_status
     * @secure
     */
    getInsertionJobStatusApiV2ProspectsImportStatusPost: (data: ImportJobsPayload, params: RequestParams = {}) =>
      this.request<ImportJobsResponse, HTTPValidationError>({
        path: `/api/v2/prospects/import_status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a prospect by search strings, can be phone, email, id, tags
     *
     * @name GetProspectApiV2ProspectsGetPost
     * @summary Get Prospect
     * @request POST:/api/v2/prospects/get
     * @secure
     */
    getProspectApiV2ProspectsGetPost: (data: ProspectsGetPayload, params: RequestParams = {}) =>
      this.request<Prospect[], HTTPValidationError>({
        path: `/api/v2/prospects/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all existing tags.
     *
     * @name GetTagsApiV2ProspectsTagsGet
     * @summary Get Tags
     * @request GET:/api/v2/prospects/tags
     * @secure
     */
    getTagsApiV2ProspectsTagsGet: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v2/prospects/tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Insert new tags, return tags which were inserted.
     *
     * @name InsertTagApiV2ProspectsTagsPost
     * @summary Insert Tag
     * @request POST:/api/v2/prospects/tags
     * @secure
     */
    insertTagApiV2ProspectsTagsPost: (data: TagsInsertPayload, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/api/v2/prospects/tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete tags, return tags which left after deletion.
     *
     * @name DeleteTagsApiV2ProspectsTagsDelete
     * @summary Delete Tags
     * @request DELETE:/api/v2/prospects/tags
     * @secure
     */
    deleteTagsApiV2ProspectsTagsDelete: (data: TagsDeletePayload, params: RequestParams = {}) =>
      this.request<string[], HTTPValidationError>({
        path: `/api/v2/prospects/tags`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Anonymize a prospect by id.
     *
     * @name AnonymizeProspectsApiV2ProspectsAnonymizePost
     * @summary Anonymize Prospects
     * @request POST:/api/v2/prospects/anonymize
     * @secure
     */
    anonymizeProspectsApiV2ProspectsAnonymizePost: (data: ProspectsAnonymizePayload, params: RequestParams = {}) =>
      this.request<ProspectsAnonymizeResponse, HTTPValidationError>({
        path: `/api/v2/prospects/anonymize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
